module.exports = __webpack_public_path__ + "static/media/wrong.cfd1d9b1.mp3";